import { Connection, PublicKey } from '@solana/web3.js';

// Use Helius RPC endpoint for better reliability
const HELIUS_API_KEY = process.env.REACT_APP_HELIUS_API_KEY;
const HELIUS_RPC_URL = `https://rpc.helius.xyz/?api-key=${HELIUS_API_KEY}`;
const connection = new Connection(HELIUS_RPC_URL, 'confirmed');

export class SolanaService {
  static getTokenSymbol(mint) {
    // This method can be expanded or call an API
    return mint.substring(0, 6) + '...';
  }

  static getCoingeckoId(symbol) {
    // This would need a more robust mapping service
    if (symbol === 'SOL') return 'solana';
    return null;
  }

  /**
   * Lightweight transaction history - focuses on recent activity only
   * This is a fallback method for when the server sync is too slow
   */
  static async getTransactionHistory(address, limit = 50) {
    try {
      console.log(`[SolanaService] Getting lightweight transaction history for ${address} (limit: ${limit})`);
      
      // Use a simple endpoint that gets recent transactions quickly
      const response = await fetch(`/api/solana/transactions?address=${address}&limit=${limit}`);
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const transactions = await response.json();
      
      console.log(`[SolanaService] Retrieved ${transactions.length} transactions via lightweight method`);
      
      // Transform to expected format
      return transactions.map(tx => ({
        blockTime: tx.timestamp || tx.blockTime,
        signature: tx.signature,
        transfers: tx.tokenTransfers || [],
        nativeTransfers: tx.nativeTransfers || []
      }));
      
    } catch (error) {
      console.error(`[SolanaService] Error fetching transaction history:`, error);
      // Return empty array as fallback
      return [];
    }
  }

  /**
   * Get current balances quickly without full sync
   */
  static async getBalances(address) {
    try {
      console.log(`[SolanaService] Getting current balances for ${address}`);
      
      // Get SOL balance
      const solBalance = await connection.getBalance(new PublicKey(address));
      
      // Get token accounts
      const tokenAccounts = await connection.getParsedTokenAccountsByOwner(
        new PublicKey(address),
        { programId: new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA') }
      );
      
      const balances = [];
      
      // Add SOL balance
      if (solBalance > 0) {
        balances.push({
          mint: 'So11111111111111111111111111111111111111112',
          symbol: 'SOL',
          balance: solBalance / 1e9,
          decimals: 9
        });
      }
      
      // Add token balances
      for (const { account } of tokenAccounts.value) {
        const { mint, tokenAmount } = account.data.parsed.info;
        if (tokenAmount.uiAmount > 0) {
          balances.push({
            mint,
            symbol: this.getTokenSymbol(mint),
            balance: tokenAmount.uiAmount,
            decimals: tokenAmount.decimals
          });
        }
      }
      
      console.log(`[SolanaService] Found ${balances.length} token balances`);
      return balances;
      
    } catch (error) {
      console.error(`[SolanaService] Error fetching balances:`, error);
      return [];
    }
  }
}

export default SolanaService; 